import styles from './_index.module.scss';

import { LINEAR } from '../../utilities/options';

export interface StepIndicatorProps {
  activeIndex: number;
  navigationType: 'linear' | 'non-linear';
  totalSteps: number;
}

const StepIndicator = ({ activeIndex, navigationType, totalSteps }: StepIndicatorProps) => {
  if (!totalSteps) {
    return;
  } // prevent divide by zero
  const stepSize = +(100 / totalSteps).toFixed(2);
  return (
    <div
      aria-valuemax={totalSteps}
      aria-valuemin={1}
      aria-valuenow={activeIndex + 1}
      className={styles['step-indicator']}
      role="progressbar"
      style={{
        left: navigationType === LINEAR ? 0 : `${stepSize * activeIndex}%`,
        width: navigationType === LINEAR ? `${stepSize * (activeIndex + 1)}%` : `${stepSize}%`,
      }}
    />
  );
};

export default StepIndicator;
